<app-confirm-dialog
   [visible]="!!confirmationMessage"
   variant="secondary"
   heading="Confirmation"
   [message]="confirmationMessage"
   cancelText="No"
   (confirmed)="confirmPendingAction()"
   (cancelled)="cancelPendingAction()">
</app-confirm-dialog>

<div class="p-g-12 posMainStyle">
   <div class="p-g-12">
      <p-tabView>
         <div class="p-g">
            <div class="p-g-12 p-table-tecfolk-fix">
               <p-table [value]="orderProduct" [paginator]="false" [rows]="10" [responsive]="true">
                  <ng-template pTemplate="caption" style="text-align: left">

                     <div class="reportMainFilter">
                        <div class="reportMainFields">
                           <div class="filterFields" *ngIf="mode == 'add'">
                              <span class="fieldTitle"> {{setLabel("searchProductByNameLabel")}}</span>
                              <input id="searchProduct" #searchProduct autocomplete="off" pinputtext=""
                                 [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="productName"
                                 [(ngModel)]="product.name" (click)="op.toggle($event)"
                                 (keyup)="searchPanelProducts($event, product.name, 'name')"
                                 class="p-inputtext p-corner-all p-state-default p-widget">
                           </div>
                           <div class="filterFields" *ngIf="mode == 'add'">
                              <span for="buyerType" class="fieldTitle">{{setLabel("buyerTypeLabel")}}</span>
                              <p-dropdown [options]="buyerTypeOptions" [(ngModel)]="buyerType"
                                 [placeholder]="setLabel('selectBuyerPlaceholderLabel')"
                                 (onChange)="onBuyerTypeChange()" styleClass="p-inputtext"></p-dropdown>
                           </div>
                           <div class="filterFields" *ngIf="mode == 'add' && buyerType === 'Customer'">
                              <span for="members" class="fieldTitle"> {{setLabel("searchCustomerLabel")}}</span>
                              <input id="searchMember" #searchMember autocomplete="off" pinputtext=""
                                 [Placeholder]='setLabel("searchMemberByNamePlaceholderLabel")' type="text" name="name"
                                 [(ngModel)]="buyerSearchText" (click)="op2.toggle($event)"
                                 (keyup)="searchPanelMember($event, buyerSearchText, 'name')"
                                 class="p-inputtext p-corner-all p-state-default p-widget">

                              <p-overlayPanel #op2 id="op2" [dismissable]="true">
                                 <div class="p-table-tecfolk-fix popdrop" style="background-color: #fff; position: fixed; width: 40vw; max-width: 84vw; max-height: 60vh;">
                                    <p-table [value]="membersInPanel" selectionMode="single" [paginator]="true" [rows]="5"
                                       [responsive]="true" (onRowSelect)="onMemberRowSelect($event, op2)"
                                       [(selection)]="selectedMember" id="op2table" #op2table [first]="first"
                                       (onPage)="onPageChange($event)">
                                       <ng-template pTemplate="header">
                                          <tr>
                                             <th> {{setLabel("tagNumberLabel")}}</th>
                                             <th> {{setLabel("imageLabel")}}</th>
                                             <th> {{setLabel("nameLabel")}}</th>
                                             <th> {{setLabel("phoneLabel")}}</th>
                                          </tr>
                                       </ng-template>
                                       <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                                          <tr [pSelectableRow]="perm" id="opRowIds-{{rowIndex}}" class="opSelectedRow">
                                             <td style="color: #000000;">{{perm.tagNumber}}</td>
                                             <td style="color: #000000;">
                                                <a>
                                                   <img style="max-width: 70px;max-height: 70px;"
                                                      onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" [src]=" perm.profile
                                                      ? config.Server + config.memberImagePath + 'thumbs/' + perm.profile
                                                      : perm.gender &&
                                                        perm.gender == 'F'
                                                      ? 'assets/layout/images/avatarGirlImage.png'
                                                      : 'assets/layout/images/avatarBoyImage.png'" />
                                                </a>
                                             </td>
                                             <td style="color: #000000;">{{perm.name}}</td>
                                             <td style="color: #000000;">{{perm.contactDetail.contact}}</td>
                                          </tr>
                                       </ng-template>
                                       <ng-template pTemplate="emptymessage" let-columns>
                                          <tr style="color: black;">
                                             <td>
                                                {{setLabel("noRecordsFoundLabel")}}
                                             </td>
                                          </tr>
                                       </ng-template>
                                    </p-table>
                                 </div>
                              </p-overlayPanel>
                           </div>
                           <div class="filterFields" *ngIf="mode == 'add' && buyerType === 'Employee'">
                              <span for="employees" class="fieldTitle"> {{setLabel("searchEmployeeLabel")}}</span>
                              <input id="searchEmployee" autocomplete="off" pinputtext=""
                                 [Placeholder]='setLabel("searchEmployeePlaceholderLabel")' type="text" name="employeeName"
                                 [(ngModel)]="buyerSearchText" (click)="openEmployeePanel($event, op3)"
                                 (keyup)="searchPanelEmployee($event, buyerSearchText, 'name')"
                                 class="p-inputtext p-corner-all p-state-default p-widget">

                              <p-overlayPanel #op3 id="op3" [dismissable]="true">
                                 <div class="p-table-tecfolk-fix popdrop" style="background-color: #fff; position: fixed; width: 40vw; max-width: 84vw; max-height: 60vh;">
                                    <p-table [value]="employeesInPanel" selectionMode="single" [paginator]="true" [rows]="5"
                                       [responsive]="true" (onRowSelect)="onEmployeeRowSelect($event, op3)"
                                       [(selection)]="selectedEmployee" id="op3table" #op3table [first]="first"
                                       (onPage)="onPageChange($event)">
                                       <ng-template pTemplate="header">
                                          <tr>
                                             <th>{{setLabel("userCodeLabel")}}</th>
                                             <th>{{setLabel("nameLabel")}}</th>
                                             <th>{{setLabel("phoneLabel")}}</th>
                                          </tr>
                                       </ng-template>
                                       <ng-template pTemplate="body" let-emp let-rowIndex="rowIndex">
                                          <tr [pSelectableRow]="emp" id="op3RowIds-{{rowIndex}}" class="opSelectedRow">
                                             <td style="color: #000000;">{{emp.userCode}}</td>
                                             <td style="color: #000000;">{{emp.name}}</td>
                                             <td style="color: #000000;">{{emp.phone}}</td>
                                          </tr>
                                       </ng-template>
                                       <ng-template pTemplate="emptymessage" let-columns>
                                          <tr style="color: black;">
                                             <td>{{setLabel("noRecordsFoundLabel")}}</td>
                                          </tr>
                                       </ng-template>
                                    </p-table>
                                 </div>
                              </p-overlayPanel>
                           </div>



                           <app-action-button
                              variant="secondary"
                              size="sm"
                              text="Go Back"
                              icon="pi pi-arrow-left"
                              title="Go Back"
                              ariaLabel="Go Back"
                              [disabled]="loading"
                              [routerLink]="mode=='edit' && newSaleOrder.orderStatus == 'quotation' ? '/sales/quotations' : '/sale-orders'">
                           </app-action-button>
                        </div>
                        <div class="reportMainBtn">
                           <!-- <button routerLink="/sale-orders"
                              class="go-Back-Btn p-g-12 p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                                 class=" fa fa-arrow-left" style="margin-right: 8px;"></i>Go
                              Back
                           </button> -->
                           <button (click)="printSaleInvoice()" *ngIf="mode == 'edit'"
                              class="change-Status-Btn p-button p-widget p-state-default p-corner-all p-button-text-only"
                              [pTooltip]='setLabel("printBtnLabel")' tooltipPosition="top">
                              <i class="fa fa-print" style="margin-right: 8px;"></i>
                              {{setLabel("printBtnLabel")}}
                           </button>
                           <button (click)="changeDeliveryStatus()"
                              style="background-color: #58a027; margin-right: 8px;"
                              *ngIf="mode == 'edit' && newSaleOrder.status != 'POS' "
                              class="p-button p-widget p-state-default p-corner-all p-button-text-only"
                              [pTooltip]='setLabel("changeStatusTooltipLabel")' tooltipPosition="top"
                              [disabled]="newSaleOrder.status == 'DELIVERED'">
                              <i class="fa fa-thumbs-up" style="margin-right: 8px;"></i>
                              {{deliveryStatusButtonString}}
                           </button>
                        </div>
                     </div>
                     <p-overlayPanel #op id="op" [dismissable]="true">
                        <div class="p-table-tecfolk-fix"
                           style="background-color: #fff; width: 60vw; max-width: 60vw; max-height: 60vh;">
                           <p-table [value]="productsInPanel" selectionMode="single" [paginator]="true" [rows]="9"
                              [responsive]="true" (onRowSelect)="onProductRowSelect($event, op)"
                              [(selection)]="selectProduct" id="opPtable" #opPtable [first]="first"
                              (onPage)="onPageChange($event)">
                              <ng-template pTemplate="header">
                                 <tr>
                                    <th> {{setLabel("codeLabel")}}</th>
                                    <th> {{setLabel("imageLabel")}}</th>
                                    <th> {{setLabel("itemLabel")}}</th>
                                    <th> {{setLabel("salePriceLabel")}}</th>
                                    <th> {{setLabel("inStockLabel")}}</th>
                                    <th> {{setLabel("committedLabel")}}</th>
                                    <th> {{setLabel("typeLabel")}}</th>
                                 </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                                 <tr *ngIf="perm.type !== 'Ingredients'" [pSelectableRow]="perm"
                                    id="opRowIds-{{rowIndex}}" class="opSelectedRow product-search-row">
                                    <td [attr.data-label]="setLabel('codeLabel')" style="color: #000000;">{{perm.code}}</td>
                                    <td [attr.data-label]="setLabel('imageLabel')" style="color: #000000;">
                                       <a>
                                          <img [alt]="" [src]="getProductImageUrl(perm.imagePath)" width="30"
                                             style="vertical-align: middle" onerror="this.src = 'assets/layout/images/gymSupplimentAvatar.png'" />
                                       </a>
                                    </td>
                                    <td [attr.data-label]="setLabel('itemLabel')" style="color: #000000;">
                                       <div>{{perm.name}}</div>
                                       <small class="product-description-mobile" *ngIf="perm.description">
                                          {{perm.description}}
                                       </small>
                                    </td>
                                    <td [attr.data-label]="setLabel('salePriceLabel')" style="color: #000000;">{{perm.normalPrice | number:'1.0-0'}}</td>
                                    <td [attr.data-label]="setLabel('inStockLabel')" style="color: #000000;">{{ perm.totalQuantity >= 0 ? perm.totalQuantity : 0 }}</td>
                                    <td [attr.data-label]="setLabel('committedLabel')" style="color: #000000;">{{ perm.committedQuantity >= 0 ? perm.committedQuantity : 0 }}</td>
                                    <td [attr.data-label]="setLabel('typeLabel')" style="color: #000000;">{{perm.type}}</td>
                                 </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage" let-columns>
                                 <tr style="color: black;">
                                    <td>
                                       {{setLabel("noRecordsFoundLabel")}}
                                    </td>
                                 </tr>
                              </ng-template>
                           </p-table>
                        </div>
                     </p-overlayPanel>

                     <p-overlayPanel #op2 id="op2" [dismissable]="true">
                        <div class="p-table-tecfolk-fix"
                           style="background-color: #fff; width: 60vw; max-width: 60vw; max-height: 60vh;">
                           <p-table [value]="membersInPanel" selectionMode="single" [paginator]="true" [rows]="9"
                              [responsive]="true" (onRowSelect)="onMemberRowSelect($event, op2)"
                              [(selection)]="selectedMember" id="op2table" #op2table [first]="first"
                              (onPage)="onPageChange($event)">
                              <ng-template pTemplate="header">
                                 <tr>
                                    <th> {{setLabel("tagNumberLabel")}}</th>
                                    <th> {{setLabel("imageLabel")}}</th>
                                    <th> {{setLabel("nameLabel")}}</th>
                                    <th> {{setLabel("phoneLabel")}}</th>
                                 </tr>
                              </ng-template>
                              <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                                 <tr [pSelectableRow]="perm" id="opRowIds-{{rowIndex}}" class="opSelectedRow">
                                    <td style="color: #000000;">{{perm.tagNumber}}</td>
                                    <td style="color: #000000;">
                                       <a>
                                          <img style="max-width: 70px;max-height: 70px;"
                                             onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" [src]=" perm.profile
                                      ? config.Server + config.memberImagePath + 'thumbs/' + perm.profile
                                      : perm.gender &&
                                        perm.gender == 'F'
                                      ? 'assets/layout/images/avatarGirlImage.png'
                                      : 'assets/layout/images/avatarBoyImage.png'" />
                                       </a>
                                    </td>
                                    <td style="color: #000000;">{{perm.name}}</td>
                                    <td style="color: #000000;">{{perm.contactDetail.contact}}</td>
                                 </tr>
                              </ng-template>
                              <ng-template pTemplate="emptymessage" let-columns>
                                 <tr style="color: black;">
                                    <td>
                                       {{setLabel("noRecordsFoundLabel")}}
                                    </td>
                                 </tr>
                              </ng-template>
                           </p-table>
                        </div>
                     </p-overlayPanel>

                  </ng-template>
                  <ng-template pTemplate="header">
                     <tr>
                        <th style="max-width: 130px;"> {{setLabel("actionLabel")}}</th>
                        <th style="max-width: 90px;"> {{setLabel("codeLabel")}}</th>
                        <th style="max-width: 130px;"> {{setLabel("itemLabel")}}</th>
                        <!-- <th style="max-width: 130px;">Previous Price</th> -->
                        <th style="max-width: 130px;"> {{setLabel("quantityLabel")}}</th>
                        <th style="max-width: 130px;"> {{setLabel("unitPriceLabel")}}</th>
                        <!-- <th style="max-width: 130px;">Discount</th> -->
                        <th style="max-width: 130px;"> {{setLabel("salesTaxLabel")}}</th>
                        <th style="max-width: 130px;"> {{setLabel("sub-TotalLabel")}}</th>
                     </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                     <tr class="posProductItem">
                        <td>
                           <div class="mobile-Lable">{{setLabel("actionLabel")}}</div>

                           <button pButton (click)="removeSelectedProduct(rowData)" type="button"
                              [pTooltip]='setLabel("removeTooltipLabel")' icon="fa fa-times" [disabled]="mode == 'edit'"
                              class="posProductActionBtn">
                           </button>
                        </td>
                        <td>
                           <div class="mobile-Lable">{{setLabel("codeLabel")}}</div>

                           {{rowData.code}}
                        </td>
                        <td>
                           <div class="mobile-Lable">{{setLabel("itemLabel")}}</div>

                           {{rowData.name}}
                        </td>
                        <!-- <td>{{rowData.prePrice}}</td> -->
                        <!-- <td>{{rowData.totalQuantity}}</td>
                        <td>{{rowData.normalPrice}}</td>
                        <td>{{rowData.discount}}</td> -->
                        <td>
                           <div class="mobile-Lable">{{setLabel("quantityLabel")}}</div>

                           <input id="rowQuantity-{{rowIndex}}" *ngIf="mode == 'add'"
                              (ngModelChange)="ProductQuantityChange($event, rowData)" pinputtext="" autocomplete="off"
                              type="number" name="quantity" class="itemInputStyles" [(ngModel)]="rowData.quantity"
                              min="1" oninput="this.value=Math.max(0,this.value);"
                              [attr.max]="rowData.type !== 'Ingredients Based' ? rowData.totalQuantity : minValue" />
                           <span *ngIf="mode == 'edit'">{{rowData.quantity}}</span>
                        </td>
                        <td>
                           <!-- <input id="rowUnitPrice-{{rowIndex}}"
                              pinputtext="" autocomplete="off" type="number" name="unitPrice" class="itemInputStyles"
                              (ngModelChange)="PriceQuantityChange($event, rowData)"
                              [(ngModel)]="rowData.unitPrice" min="0" /> -->
                           <div class="mobile-Lable">{{setLabel("unitPriceLabel")}}</div>

                           {{rowData.unitPrice | number:'1.0-0'}}
                        </td>
                        <!-- <td>
                           <div class="mobile-Lable">Discount</div>

                           <input id="rowDiscount-{{rowIndex}}" pinputtext="" autocomplete="off" type="number"
                              name="discount" class="itemInputStyles" *ngIf="mode == 'add'"
                              (ngModelChange)="DiscountQuantityChange($event, rowData)" [(ngModel)]="rowData.discount"
                              min="0">
                           <span *ngIf="mode == 'edit'">{{rowData.discount}}</span>
                        </td> -->
                        <td>
                           <div class="mobile-Lable">{{setLabel("salesTaxLabel")}}</div>

                           {{rowData.vatTax | number:'1.0-0'}}
                        </td>
                        <td>
                           <div class="mobile-Lable">{{setLabel("sub-TotalLabel")}}</div>

                           {{rowData.subTotal | number:'1.0-0'}}
                        </td>
                     </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                     <tr>
                        <td>
                           {{setLabel("noProductAddedLabel")}}
                        </td>
                     </tr>
                  </ng-template>
                  <!-- <ng-template pTemplate="footer">
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Sub-Total</td>
                        <td style="font-size: 16px; font-weight: 700; background-color:#f4f4f4">{{newSaleOrder.subTotal}}</td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Discount</td>
                        <td style="background-color:#f4f4f4">
                           <input pinputtext="" autocomplete="off" type="number" name="discount" [(ngModel)]="newSaleOrder.discount"
                            class="p-corner-all p-state-default p-widget" style="width: 100%;">
                        </td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Total</td>
                        <td style="font-size: 16px; font-weight: 700; background-color:#f4f4f4">{{newSaleOrder.remainingSubtotal}}</td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Total Tax</td>
                        <td style="font-size: 16px; font-weight: 700; background-color:#f4f4f4">{{newSaleOrder.vatTax}}</td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Grand Total</td>
                        <td style="font-size: 16px; font-weight: 700; background-color:#f4f4f4">{{newSaleOrder.total}}</td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Cash</td>
                        <td style="background-color:#f4f4f4">
                           <input pinputtext="" autocomplete="off" type="number" name="cash" [(ngModel)]="newSaleOrder.paid"
                            class="p-corner-all p-state-default p-widget" style="width: 100%;" >
                        </td>
                     </tr>
                     <tr >
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="font-size: 16px; font-weight: 500; background-color:#f4f4f4">Return Amount</td>
                        <td style="background-color:#f4f4f4">
                           <input pinputtext="" readonly autocomplete="off" type="number" name="return" [(ngModel)]="newSaleOrder.balance"
                           class="p-corner-all p-state-default p-widget" style="width: 100%;">
                        </td>
                     </tr>

                     <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="background-color:#f4f4f4">
                           <button style="background-color: #ffffff; margin-right: 8px; width: 100%; color: red; border: 2px solid red;"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              Suspend
                           </button>
                        </td>
                        <td style="background-color:#f4f4f4">
                           <button style="background-color: #5192d0; margin-right: 8px; width: 100%;"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              Checkout
                           </button>
                        </td>
                     </tr>
                  </ng-template> -->
               </p-table>
               <!-- Extra Ingredients Pop-up -->
               <p-dialog header="Extra Ingredients" [responsive]="true" [(visible)]="extraIngredientsDialogVisibility"
                  [modal]="true">
                  <div *ngIf="(ingredients && ingredients.length > 0)">
                     <h3 class="first"> {{setLabel("extraIngredientsLabel")}}</h3>
                     <div style="display: flex; justify-content: space-between;" class="p-g p-fluid"
                        *ngFor="let ingredient of ingredients; let i = index">
                        <div class="p-g-4">
                           <label *ngIf="i == 0" for="ingredientName{{ i }}"><strong>
                                 {{setLabel("ingredientNameLabel")}}</strong></label>
                           <input style="margin-top: 10px;" id="ingredientName{{ i }}" type="text"
                              [(ngModel)]="ingredient.name" readonly />
                        </div>
                        <div class="p-g-3">
                           <label *ngIf="i == 0" for="ingredientQuantity{{ i }}"><strong>
                                 {{setLabel("quantityLabel")}}</strong></label>
                           <div style="margin-top: 10px;" class="quantity-input">
                              <button pButton type="button" (click)="decreaseQuantity(ingredient,i)">-</button>
                              <input type="number" [(ngModel)]="ingredient.quantity" min="0" style="width: 50px;"
                                 readonly />
                              <button pButton type="button" (click)="increaseQuantity(ingredient, i)"
                                 [disabled]="!areIngredientsEnoughArray[i]">+</button>
                           </div>
                        </div>
                        <div class="p-g-2">
                           <label *ngIf="i == 0" for="ingredientUnit{{ i }}"><strong>
                                 {{setLabel("unitLabel")}}</strong></label>
                           <input style="margin-top: 10px;" class="unit-input " id="ingredientUnit{{ i }}" type="text"
                              [(ngModel)]="ingredient.unit" readonly />
                        </div>
                     </div>
                  </div>
                  <p-footer class="p-footer">
                     <button pButton type="button" [label]='setLabel("doneLabel")'
                        (click)="closeExtraIngredientsDialog()"></button>
                  </p-footer>
               </p-dialog>
               <!-- Extra Ingredients Pop-up -->
               <!-- <form #pointOfSaleForm="ngForm"> -->
               <p-table [value]="[newSaleOrder]" [paginator]="false" [rows]="10" [responsive]="true">
                  <ng-template pTemplate="footer">
                     <tr>
                        <td class="td-Hide">
                           <!-- <form #deliveryOptionsForm="ngForm">
                              <h3 style="margin: 0;">Delivery Options</h3>
                              <div style="display: flex; align-items: center; justify-content: end;">
                                 <span style="font-size:12px; display: inline-block; padding-bottom: 2px;">(Press F8 to
                                    add delivery options)&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                 <p-inputSwitch name="Is_Delivery_Enabled" (onChange)="handleSwitchChange($event)"
                                    [(ngModel)]="newSaleOrder.isDeliveryEnabled" [disabled]="mode == 'edit'">
                                 </p-inputSwitch>
                              </div>
                              <div style="display: flex;">
                                 <div style="display: flex; flex-direction: column; flex-grow: 1; padding-right: 15px;">
                                    <Label style="font-size: 12px;">First Name <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #firstName="ngModel"
                                       [ngClass]="firstName.invalid && (firstName.dirty || firstName.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.firstName"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryFirstName" required
                                       name="firstName" />
                                 </div>

                                 <div style="display: flex; flex-direction: column;flex-grow: 1;">
                                    <Label style="font-size: 12px;">Last Name <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #lastName="ngModel"
                                       [ngClass]="lastName.invalid && (lastName.dirty || lastName.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.lastName"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryLastName" required
                                       name="lastName" />
                                 </div>
                              </div>
                              <div style="display: flex;">
                                 <div style="display: flex; flex-direction: column;flex-grow: 1; padding-right: 15px;">
                                    <Label style="font-size: 12px;">Email <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #email="ngModel"
                                       [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.email"
                                       pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryEmail" name="email"
                                       required />
                                 </div>

                                 <div style="display: flex; flex-direction: column;flex-grow: 1;">
                                    <Label style="font-size: 12px;">Mobile Number <span
                                          style="color: red">*</span></Label>
                                    <app-phone-input
                                       id="deliveryPhone"
                                       name="phone"
                                       placeholder="Mobile Number *"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.contact"
                                       [required]="newSaleOrder.isDeliveryEnabled"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled">
                                    </app-phone-input>
                                 </div>
                              </div>
                              <div style="display: flex;">
                                 <div style="display: flex; flex-direction: column;flex-grow: 1;padding-right: 15px;">
                                    <Label style="font-size: 12px;">Street <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #street="ngModel"
                                       [ngClass]="street.invalid && (street.dirty || street.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.deliveryAddress.street"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryAddress" required
                                       name="street" />
                                 </div>
                                 <div style="display: flex; flex-direction: column;flex-grow: 1;">
                                    <Label style="font-size: 12px;">City <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #city="ngModel"
                                       [ngClass]="city.invalid && (city.dirty || city.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.deliveryAddress.city"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryCity" required
                                       name="city" />
                                 </div>
                              </div>
                              <div style="display: flex;">
                                 <div style="display: flex; flex-direction: column;flex-grow: 1;padding-right: 15px;">
                                    <Label style="font-size: 12px;">State <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #state="ngModel"
                                       [ngClass]="state.invalid && (state.dirty || state.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.deliveryAddress.state"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryState" required
                                       name="state" />
                                 </div>
                                 <div style="display: flex; flex-direction: column;flex-grow: 1;">
                                    <Label style="font-size: 12px;">ZIP Code <span style="color: red">*</span></Label>
                                    <input type="text" style="width:100%;" #zipCode="ngModel"
                                       [ngClass]="zipCode.invalid && (zipCode.dirty || zipCode.touched) ? 'errorInput': ''"
                                       [(ngModel)]="newSaleOrder.deliveryContactDetails.deliveryAddress.zipCode"
                                       [disabled]="!newSaleOrder.isDeliveryEnabled" id="deliveryZIPCode" required
                                       name="zip" />
                                 </div>
                              </div>
                           </form> -->
                        </td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("sub-TotalLabel")}}
                        </td>
                        <td colspan="2" class="colspan"
                           style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                           {{newSaleOrder.subTotal | number:'1.0-0'}}</td>
                     </tr>
                     <tr *ngIf="mode=='add' && branch?.permissions?.showQuotation === true">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2" style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("quotationLabel")}}</td>
                        <td class="colspan" colspan="2" style=" background-color:#edf1ff; text-align:left;">
                           <input class="big-checkbox" style="max-width:fit-content;" type="checkbox" [(ngModel)]="isQuotation" />
                        </td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("discountLabel")}}
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <input pinputtext="" id="overallDiscount" *ngIf="mode == 'add'" #overallDiscount
                              autocomplete="off" type="number" name="discount" [(ngModel)]="newSaleOrder.discount"
                              class="itemInputStyles" style="width: 100%;" (ngModelChange)="onOverallDiscountChange()"
                              min="0" name="overallDiscount"  oninput="this.value=Math.max(0,this.value);">
                           <span *ngIf="mode == 'edit'">{{newSaleOrder.discount | number:'1.0-0'}}</span>
                           <div *ngIf="newSaleOrder.discount > newSaleOrder.subTotal" class="errorShow">
                           {{setLabel("discountErrorLabel")}}
                        </div>
                        </td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("totalLabel")}}</td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                           {{newSaleOrder.remainingSubtotal | number:'1.0-0'}}</td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("totalTaxLabel")}}
                        </td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                           {{newSaleOrder.vatTax | number:'1.0-0'}}
                        </td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("grandTotalLabel")}}
                        </td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                           {{newSaleOrder.total | number:'1.0-0'}}<br>
                           <i *ngIf="taxType == 'INCLUDING_TAX'" style="font-weight: bold; color: blue; font-size: 12px;">
                              {{(newSaleOrder.subTotal - newSaleOrder.discount) * taxRate / 100}} {{setLabel("taxIncludedLabel")}}
                           </i>
                        </td>
                     </tr>
                     <ng-container *ngIf="!(mode == 'edit' && newSaleOrder.orderStatus == 'quotation')">
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("paymentModeLabel")}}
                        </td>
                        <td class="colspan paymentModeValueCell" colspan="2"
                           style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                           <p-dropdown class="p-g-8" [options]="hasOpenPayLater() ? settlePaymentOptions : getCreatePaymentOptions()"
                              [(ngModel)]="paymentMode" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                        </td>
                     </tr>
                     <tr *ngIf="(isQuotation==false && !isPayLaterMode()) || (mode == 'edit' && hasOpenPayLater())">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           <span> {{setLabel("paymentReceivedLabel")}}</span>
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <input pinputtext="" id="paymentReceived" *ngIf="mode == 'add'" autocomplete="off"
                              type="number" name="cash" [(ngModel)]="newSaleOrder.paid" class="itemInputStyles"
                              (ngModelChange)="calculateBalance(newSaleOrder.paid)" style="width: 100%;"
                              name="paymentReceived" [attr.min]="newSaleOrder.total"
                              oninput="this.value=Math.max(0,this.value);">
                           <input pinputtext="" id="paymentReceivedSettle" *ngIf="mode == 'edit' && hasOpenPayLater()"
                              autocomplete="off" type="number" name="paymentReceivedSettle"
                              [(ngModel)]="payRemainingBalance" class="itemInputStyles"
                              (ngModelChange)="calculateBalance(payRemainingBalance)" style="width: 100%;"
                              [attr.min]="getPayLaterAmountDue()"
                              oninput="this.value=Math.max(0,this.value);">
                           <span *ngIf="mode == 'edit' && !hasOpenPayLater()">{{newSaleOrder.paid | number:'1.0-0'}}</span>
                           <div *ngIf="mode == 'add' && !isQuotation && newSaleOrder.paid > 0 && newSaleOrder.paid < newSaleOrder.total" class="errorShow">
                              Payment received should not be less than Grand Total
                           </div>
                           <div *ngIf="mode == 'edit' && hasOpenPayLater() && payRemainingBalance > 0 && payRemainingBalance < getPayLaterAmountDue()" class="errorShow">
                              Payment received should not be less than Grand Total
                           </div>
                        </td>
                     </tr>
                     <tr *ngIf="mode == 'add' && isPayLaterMode()">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("payLaterAmountDueLabel")}}
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           {{newSaleOrder.total | number:'1.0-0'}}
                        </td>
                     </tr>
                     <tr *ngIf="mode == 'edit' && hasOpenPayLater()">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("payLaterAmountDueLabel")}}
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           {{getPayLaterAmountDue() | number:'1.0-0'}}
                        </td>
                     </tr>
                     <tr *ngIf="mode == 'edit' && !hasOpenPayLater() && (remainingBalance > 0 || payRemainingBalance > 0)">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           <span> {{setLabel("payRemainingBalanceLabel")}}</span>
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <input pinputtext="" id="payRemainingBalance" autocomplete="off"
                              type="number" name="cash" [(ngModel)]="payRemainingBalance" class="itemInputStyles"
                              (ngModelChange)="calculateBalance(payRemainingBalance)" style="width: 100%;"
                              name="payRemainingBalance" oninput="this.value=Math.max(0,this.value);">
                           <!-- <span *ngIf="mode == 'edit'">{{newSaleOrder.paid | number:'1.0-0'}}</span> -->
                        </td>
                     </tr>

                     <tr *ngIf="remainingBalance > 0">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("remainingBalanceLabel")}}</td>

                        <!-- <td *ngIf="mode=='edit'"  class="colspan" colspan="2" style="background-color:#edf1ff">
                           <input pinputtext="" autocomplete="off" type="number" name="remainingBalance"
                              [ngModel]="remainingBalance" (ngModelChange)="calculateRemainingBalance(newSaleOrder.paid)" class="itemInputStyles" style="width: 100%;" >
                        </td> -->
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           {{remainingBalance | number:'1.0-0'}}</td>
                     </tr>


                     <tr *ngIf="newSaleOrder.returned >0">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("balanceReturnedLabel")}}</td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           {{newSaleOrder.returned | number:'1.0-0'}}
                           <!-- <input pinputtext="" readonly autocomplete="off" type="number" name="return" [(ngModel)]="newSaleOrder.returned"
                              class="p-corner-all p-state-default p-widget" style="width: 100%;" > -->
                        </td>
                     </tr>
                     <tr *ngIf="mode == 'edit' && (resolveBuyerType() === 'Customer' || resolveBuyerType() === 'Employee')">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("buyerTypeLabel")}}
                        </td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           {{resolveBuyerType()}}
                        </td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2"
                           style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("soldToLabel")}}</td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <div style="display: flex;justify-content: space-between;">
                                 <input type="text" pinputtext="" autocomplete="off" id="soldToInput"
                                    name="soldToInput" style="width: 100%;"
                                    [ngModel]="mode == 'edit' ? resolveBuyerName() : memberName"
                                    (ngModelChange)="mode != 'edit' && (memberName = $event)"
                                    [disabled]="mode == 'edit'"
                                     />
                                 </div>
                              <div (click)="resetSoldTo()" style="cursor: pointer;"
                                 *ngIf="memberName !== 'Walk in Customer' && (selectedMember || selectedEmployee) && mode != 'edit'">
                                 <i class="pi pi-times"></i>
                              </div>
                           <div *ngIf="resolveBuyerNumber()" style="font-size: 12px; color: #555; margin-top: 4px;">
                              {{ setLabel("phoneLabel") }}: {{ resolveBuyerNumber() }}
                           </div>

                        </td>
                     </tr>
                     <tr>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2" style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("soldByLabel")}}</td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <div style="display: flex;justify-content: space-between;">
                              <div>{{user.name}}</div>
                           </div>
                        </td>

                     </tr>
                     <tr style="border-bottom: 1px solid;">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <button (click)="suspendSale()" id="suspendButton"
                              style="background-color: #ffffff; margin-right: 8px; width: 100%; color: red; border: 2px solid red;"
                              [disabled]="!(orderProduct.length >= 1) || mode == 'edit'"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              {{setLabel("suspendBtnLabel")}}
                           </button>
                           </td>
                           <!-- *ngIf="!isDisableSalesOrder" -->
                           <td colspan="2" style="background-color:#edf1ff">
                           <button *ngIf="!newSaleOrder.isDeliveryEnabled; else deliveryCheckOut" (click)="checkOut()"
                              id="checkoutButton" style="background-color: #5192d0; margin-right: 8px; width: 100%;"
                              [disabled]="orderProduct.length < 1 ||
                                     isDisableSalesOrder ||
                                     (mode == 'add' && !isBuyerSelected()) ||
                                     (newSaleOrder.paid >= newSaleOrder.total && mode=='edit' && !hasOpenPayLater()) ||
                                     (hasOpenPayLater() && paymentMode === 'Pay-Later') ||
                                     (hasOpenPayLater() && (payRemainingBalance || 0) < getPayLaterAmountDue()) ||
                                     newSaleOrder.discount > newSaleOrder.subTotal"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              {{ setLabel(hasOpenPayLater() ? 'payNowBtnLabel' : (isQuotation ? 'createQuotationLabel' : 'checkoutBtnLabel')) }}
                              </button>
                              <ng-template #deliveryCheckOut>
                                 <button id="checkoutDeliveryButton" (click)="checkOutWithDeliveryOptions()"
                                    style="background-color: #5192d0; margin-right: 8px; width: 100%;"
                                    [disabled]="(!(((orderProduct.length >= 1) && (newSaleOrder.paid >= newSaleOrder.total || newSaleOrder.paid == 0)) && !isDisableSalesOrder && deliveryOptionsForm.form.valid) || mode == 'edit') || (mode == 'add' && !isBuyerSelected())"
                                    class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                                    {{setLabel("deliveryCheckoutsLabels")}}
                                 </button>
                              </ng-template>
                           </td>
                     </tr>
                     </ng-container>
                       <tr *ngIf="mode=='edit' && newSaleOrder.orderStatus == 'quotation'">
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="td-Hide"></td>
                        <td class="colspan" colspan="2" style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                           {{setLabel("soldByLabel")}}</td>
                        <td class="colspan" colspan="2" style="background-color:#edf1ff">
                           <div style="display: flex;justify-content: space-between;">
                              <div>{{user.name}}</div>
                           </div>
                        </td>

                     </tr>
                  </ng-template>
               </p-table>
               <!-- </form> -->
            </div>
         </div>
      </p-tabView>
   </div>
</div>
<div id="salesInvoice" style="display: none;">
   <div class="invoice-box" style="padding: 5px !important;  width: 63mm; max-width: 63mm; margin: 0 !important;">
   <div style="width:57mm; display:flex; align-items:center;"
      [style.justify-content]="branch?.invoiceData?.bannerImage?.length === 1 ? 'center' : 'space-between'">
      <div *ngFor="let banner of branch?.invoiceData?.bannerImage" style="width:50%; text-align:center;">
         <img [src]="banner?.image
           ? config.Server + 'assets/layout/images/companies/' + banner.image
           : 'assets/layout/images/logoCompany.png'" alt="Company Logo"
               style="width:100%; margin-top:3px; margin-bottom:2px;" />
         </div>
      </div>



      <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">{{ branch.invoiceData.name }}</div>
      <div style="text-align: center;font-size: 11px;line-height: 14px;color: black;">{{ branch.invoiceData.address }}</div>
      <div *ngIf="branch.invoiceData.contact.length === 1"
         style="text-align: center;font-size: 11px;line-height: 15px;color: black;">{{branch.invoiceData.contact[0].contactNumber }}</div>
      <div *ngIf="branch.invoiceData.contact.length > 1"
         style="text-align: center;font-size: 11px;line-height: 15px;color: black;">
         <div *ngFor="let c of branch.invoiceData.contact">
            {{ c.contactNumber }}
         </div>
      </div>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
            <tbody>
               <tr>
                  <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">
                     {{setLabel("billInvoice#Label")}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">
                     {{setLabel("createdLabel")}}</td>
               </tr>
               <tr >
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newSaleOrder.invoiceNumber}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newSaleOrder.invoiceDate | date:'d/M/yy, h:mm a'}}</td>
               </tr>
            </tbody>
         </table>
         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
            <thead
               style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
               <tr style="background-color: black;color: white; border: 1px solid black;">
                  <th style="word-break: break-word; font-size: 10px;" colspan="2"> {{setLabel("itemLabel")}}</th>
                  <th style="word-break: break-word; font-size: 10px;" colspan="2"> {{setLabel("qTYLabel")}}</th>
                  <th style="word-break: break-word; font-size: 10px;" colspan="2"> {{setLabel("unitPriceLabel")}}</th>
               </tr>
            </thead>
            <tbody>
               <span>
                  <tr *ngFor="let item of newSaleOrder.products">
                     <td style="font-size: 10px;border:1px solid black;text-align: center;" colspan="2">{{item.name}}</td>
                     <td style="font-size: 10px;border:1px solid black;text-align: center;"colspan="2">{{item.quantity}}</td>
                     <td style="font-size: 10px;border:1px solid black;text-align: center;"colspan="2">{{item.unitPrice | number:'1.0-0'}}</td>
                  </tr>
               </span>
               <tr>
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("sub-TotalLabel")}} </td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.subTotal | number:'1.0-0'}}</td>
               </tr>
               <tr *ngIf="+(newSaleOrder.discount || 0) > 0">
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("flatDiscLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.discount | number:'1.0-0'}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("totalTaxLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.vatTax | number:'1.0-0'}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("netAmountLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.total | number:'1.0-0'}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("paymentReceivedLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.paid | number:'1.0-0'}}</td>
               </tr>
               <tr *ngIf="newSaleOrder.remainingBalance > 0 && newSaleOrder.orderStatus != 'quotation' ">
                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("remainingBalanceLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.remainingBalance | number:'1.0-0'}}</td>
               </tr>
               <tr *ngIf="newSaleOrder.returned > 0">

                  <td style="font-size: 10px; text-align: start;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="5"> {{setLabel("balanceReturnedLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; font-weight: bold;
                                           border-bottom: 1px solid;">{{newSaleOrder.returned | number:'1.0-0'}}</td>
               </tr>
               <div style="display: flex;justify-content: space-around; border:1px solid black; margin-top: 5px;">
                  <div style="display: flex; flex-direction: column;line-height: 1.5;">
                     <label style="font-size: 11px; font-weight: bold;"> {{setLabel("soldToLabel")}}</label>
                     <label style="font-size: 11px; font-weight: bold;">{{mode == 'edit' ? resolveBuyerName() : (newSaleOrder.soldTo?.name || memberName)}}</label>
                     <label *ngIf="resolveBuyerNumber()" style="font-size: 10px; font-weight: bold;">
                        {{ setLabel("phoneLabel") }}: {{ resolveBuyerNumber() }}
                     </label>
                  </div>
                  <div style="display: flex; flex-direction: column;line-height: 1.5;">
                     <label style="font-size: 11px; font-weight: bold;"> {{setLabel("soldByLabel")}}</label>
                     <label style="font-size: 11px; font-weight: bold;">{{user.name}}</label>
                  </div>
               </div>
            </tbody>
         </table>
         <div *ngIf="invoiceMessage"   style="text-align: center;padding-top: 16px;font-size: 10px;font-family:'Times New Roman';color: black;line-height: 18px; word-break: break-all;">
            {{invoiceMessage}}
         </div>
         <div
            style=" text-align: center;padding-top: 6px; font-size: 9px; font-weight: bold;color: black;">
            {{setLabel("softwareLabel")}}
         </div>
   </div>
</div>